/**
 * Un visor de PDF con su propia barra (páginas, rotar, zoom). Cada instancia
 * crea SUS plugins: los de @react-pdf-viewer se enlazan a un solo <Viewer>,
 * así que dos paneles lado a lado no pueden compartirlos (ver
 * PdfPreviewDrawer en file.js, que se deja como está).
 */

import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { LeftOutlined, RightOutlined, RotateRightOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Worker, Viewer, RotateDirection } from '@react-pdf-viewer/core';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { rotatePlugin } from '@react-pdf-viewer/rotate';
import '@react-pdf-viewer/core/lib/styles/index.css';

const WORKER_URL = 'https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js';

export const PdfViewerPane = ({ url, height = '70vh' }) => {
  // Los plugins se crean en el cuerpo, en CADA render, como en file.js: por
  // dentro usan hooks (useMemo) que los mantienen estables. Meterlos en el
  // inicializador de useState los corría solo al montar, y el segundo render
  // cambiaba el orden de los hooks: React tumbaba toda la app.
  const nav = pageNavigationPlugin();
  const zoom = zoomPlugin();
  const rotate = rotatePlugin();
  const [scale, setScale] = useState(1);
  const { jumpToNextPage, jumpToPreviousPage, CurrentPageLabel, NumberOfPages } = nav;
  const { Rotate } = rotate;
  const zoomBy = (delta) => {
    const next = Math.min(4, Math.max(0.5, Math.round((scale + delta) * 10) / 10));
    setScale(next);
    zoom.zoomTo(next);
  };

  return (
    <div>
      <Space wrap style={{ marginBottom: 8 }}>
        <Button size="small" icon={<LeftOutlined />} onClick={jumpToPreviousPage} />
        <span><CurrentPageLabel /> / <NumberOfPages /></span>
        <Button size="small" icon={<RightOutlined />} onClick={jumpToNextPage} />
        <Rotate direction={RotateDirection.Forward}>
          {(props) => <Button size="small" icon={<RotateRightOutlined />} onClick={props.onClick}>Rotar</Button>}
        </Rotate>
        <Button size="small" icon={<ZoomOutOutlined />} onClick={() => zoomBy(-0.25)} />
        <Button size="small" icon={<ZoomInOutlined />} onClick={() => zoomBy(0.25)} />
      </Space>
      <div style={{ height, border: '1px solid #f0f0f0' }}>
        <Worker workerUrl={WORKER_URL}>
          <Viewer fileUrl={url} plugins={[nav, zoom, rotate]} />
        </Worker>
      </div>
    </div>
  );
};

export default PdfViewerPane;
